import React, {useEffect, useState} from "react";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import {VsiBubble, VsiH4, VsiH5, VsiSpanText} from "../../../styled/App.styled";
import Grid from "../../../components/Grid";
import {dateFormatter, numberFormatter, percentageBarFormatter} from "../../../utils/gridFormatters";
import { Card, Col, Container, Input, Row, Spinner } from "reactstrap";
import DonutChart from "../../../components/DonutChart";
import BarChart from "../../../components/BarChart";
import {genericColors} from "../../../utils/chartUtils";
import Select from "react-select";
import {GetAuth} from "../../../utils/Verbs";
import VsiLabeledSelect from "../../../components/VsiLabeledSelect";

// build a map, and render wihout it in dorpdown

export default function SecurityDashboard({title, context}) {
    // const ad_user_status = [
    //     {name: 'SCRIPT', value: 1, description: 'script'},
    //     {name: 'ACCOUNTDISABLE', value: 2, description: 'Account Disabled'},
    //     {name: 'HOMEDIR_REQUIRED', value: 8, description: 'Home Directory Required'},
    //     {name: 'LOCKOUT', value: 16, description: 'Locked Out'},
    //     {name: 'PASSWD_NOTREQD', value: 32, description: 'Password not Required'},
    //     {name: 'PASSWD_CANT_CHANGE', value: 64, description: 'Password Cannot Change'},
    //     {name: 'ENCRYPTED_TEXT_PWD_ALLOWED', value: 128, description: 'Encrypted Text Password Allowed'},
    //     {name: 'TEMP_DUPLICATE_ACCOUNT', value: 256, description: 'Temporary Duplicated Account'},
    //     {name: 'NORMAL_ACCOUNT', value: 512, description: 'Normal Account'},
    //     {name: 'INTERDOMAIN_TRUST_ACCOUNT', value: 2048, description: 'Inter Domain Trust Account'},
    //     {name: 'WORKSTATION_TRUST_ACCOUNT', value: 4096, description: 'Workstation Trust Account'},
    //     {name: 'SERVER_TRUST_ACCOUNT', value: 8192, description: 'Server Trust Account'},
    //     {name: 'DONT_EXPIRE_PASSWORD', value: 65536, description: 'Password do NOT Expire'},
    //     {name: 'MNS_LOGON_ACCOUNT', value: 131072, description: 'MNS Logon Account'},
    //     {name: 'SMARTCARD_REQUIRED', value: 262144, description: 'Smart Card Required'},
    //     {name: 'TRUSTED_FOR_DELEGATION', value: 524288, description: 'Trusted for Delegation'},
    //     {name: 'NOT_DELEGATED', value: 1048576, description: 'Not Delegated'},
    //     {name: 'USE_DES_KEY_ONLY', value: 2097152, description: 'Use DES Key only'},
    //     {name: 'DONT_REQ_PREAUTH', value: 4194304, description: 'Do NOT required Pre-Authentication'},
    //     {name: 'PASSWORD_EXPIRED', value: 8388608, description: 'Password Expired'},
    //     {
    //         name: 'TRUSTED_TO_AUTH_FOR_DELEGATION',
    //         value: 16777216,
    //         description: 'Trusted to Authentication for Delegation'
    //     },
    //     {name: 'PARTIAL_SECRETS_ACCOUNT', value: 67108864, description: 'Partial Secrets Account'}
    // ]
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();
    const [pieChart, setPieChart] = useState([]);
    const [chartSeries, setChartSeries] = useState([]);
    // Device Options and Logs
    const [deviceOptions, setDeviceOptions] = useState([]);
    const [selectedDevice, setSelectedDevice] = useState({});
    const [deviceLogValues, setDeviceLogValues] = useState({});

    let route = `/api/v6/report/active_directory_users_proc?client_id=${client.clientId}&period_id=${periodId}`;
    const [data, {isLoading}] = useDataWithRoute(route);
    const [devicesData] = useDataWithRoute(`/api/v6/admin/parser_all_logs/${client.clientId}`);
    // const [log_result] = useDataWithRoute(`/api/v6/admin/parser_logs/${client.clientId}/${selectedDevice?.value?.replace('/', '_')}`, selectedDevice);
    const [defaultPassData] = useDataWithRoute(`/api/v6/report/devices_with_default_passwords_proc?client_id=${client.clientId}&period_id=${periodId}`, selectedDevice);
    const [defaultPassDevices, setDefaultPassDevices] = useState([]);

    useEffect(() => {
        setDefaultPassDevices(defaultPassData.recordset?.map(d => {
            return d['device_name'];
        }));
    }, [defaultPassData])
    useEffect(() => {
        setPieChart([
                {name: 'New Users', y: data?.recordsets[0]?.[0]?.['new_users']},
                {name: 'Users w/ Expired Password', y: data?.recordsets[0]?.[0]?.['expire_passwords']},
                {name: "Stale Users (hasn't logged in for over a month)", y: data?.recordsets[0]?.[0]?.['stale_users']},
                {name: 'Privileged Users', y: data?.recordsets[0]?.[0]?.['privileged_users']},
                {name: 'Normal Users', y: data?.recordsets[0]?.[0]?.['normal_users']},
            ]
        );

        let series = data?.recordsets[1]?.map(s => {
            return {
                name: s['ad_domain'],
                data: [s['normal_users'], s['locked_users'], s['privileged_groups'], s['inherited_privileges_users'],
                    s['expired_passwords'], s['no_expire_passwords'], s['expicitly_privileged_users']]
            }
        });
        setChartSeries(series);

    }, [data]);

    function formatDeviceFileString(d) {
        return `${d.deviceName || 'UnknownDevice'}-${d.fileName || 'UnknownFile'}`;
    }

    useEffect(() => {
        if (!devicesData?.recordset?.length) return;
        const nameToVal = devicesData?.recordset.reduce((acc, item) => {
            acc[formatDeviceFileString(item)] = item.collectionLog || '';
            return acc;
        }, {});
        setDeviceLogValues(nameToVal)
        setDeviceOptions(devicesData?.recordset?.map(d => {
            return {label: d['deviceName'], value: formatDeviceFileString(d)};
        }));
        setSelectedDevice({
            label: devicesData?.recordset?.[0]?.['deviceName'],
            value: devicesData?.recordset?.[0]?.['collectionLog']
        });
    }, [devicesData])
    // useEffect(() => {
    //     if (log_result) {
    //         setCollectionLog(log_result['collectionLog']);
    //     } else {
    //         setCollectionLog('No Collection Log Available.')
    //     }
    // }, [log_result]);
    const ad_users_categories =
        ['Normal Users', 'Locked Users', 'Priviledge Groups', 'Inherited Priviledge Users', 'Users with Expired Passwords',
            "Users w/ password that don't expire", "Explicity Priviledged Users"];

    const onChange = (selectItem) => {
        const thisDevice = {
            label: selectItem.label,
            value: deviceLogValues[selectItem.value] || ''
        }
        setSelectedDevice(thisDevice);
    }
    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Security Dashboard</VsiH4>
            {isLoading ? <Spinner color={"primary"}/> : (
                chartSeries?.length > 0 || deviceOptions.length > 0 || defaultPassDevices.length > 0 ?
                    <>
                        <Row className={`py-2`}>
                            <Col md={12} lg={6}>
                                <VsiBubble noAutobot>
                                    <Container>
                                        <DonutChart data={pieChart}
                                                    alignTitle={'center'}
                                                    title={"User Information"}
                                                    colors={genericColors}
                                                    seriesName={'# of Users'}
                                                    enableLegend={true}
                                        />

                                    </Container>
                                </VsiBubble>
                            </Col>

                            <Col md={12} lg={6}>
                                <VsiBubble noAutobot>
                                    <Container>
                                        <BarChart categories={ad_users_categories}
                                                  height={400}
                                                  series={chartSeries}
                                                  title={'Active Directory Audit'}
                                                  yAxisTitle={'# of Users'}
                                                  disableLegend={false}
                                        />
                                    </Container>
                                </VsiBubble>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} lg={6}>
                                <VsiBubble noAutobot>
                                    <VsiH5>Devices with Default Password</VsiH5>
                                    {defaultPassDevices.length > 0 ?
                                        defaultPassDevices.map(device => {
                                            return <p><VsiSpanText>{device}</VsiSpanText></p>
                                        }) :
                                        <VsiSpanText>No Devices with Default Password found.</VsiSpanText>
                                    }
                                </VsiBubble>
                            </Col>
                            <Col md={12} lg={6}>
                                <VsiBubble noAutobot>
                                    <VsiH5>Logs</VsiH5>
                                    <VsiLabeledSelect
                                        minWidth={350}
                                        classNamePrefix="select"
                                        value={selectedDevice}
                                        defaultValue={selectedDevice}
                                        isLoading={isLoading}
                                        onChange={onChange}
                                        isSearchable={true}
                                        name="color"
                                        options={deviceOptions}
                                        label={"Device"}
                                        placeholder={'Select a device...'}
                                    />

                                    <Input id="log"
                                           type="textarea"
                                           name="log"
                                           className={"w-100"}
                                           maxLength={500}
                                           rows={25}
                                           value={selectedDevice.value}/>
                                </VsiBubble>
                            </Col>
                        </Row>


                    </> :
                    <VsiSpanText>No data to display.</VsiSpanText>
            )}
        </Card>
    )
}
